/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, OnInit } from '@angular/core';
import { PipingPlumbingComponent } from '../PipingPlumbingFittingSize/piping-plumbing.component';
import { FittingSizeManagementService } from '../../sharedServices/fitting-size-management.service';
import { FormBuilder } from '@angular/forms';
import { FittingSizeDataService } from '../../sharedServices/fittingSize-data.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-cable-trays',
  templateUrl: './cable-trays.component.html',
})

export class CableTraysComponent extends PipingPlumbingComponent

  implements OnInit {

  constructor(
    dialog: MatDialog,
    snackBar: MatSnackBar,
    sharedService: FittingSizeManagementService,
    formBuilder: FormBuilder,
    fittingSizeDataService: FittingSizeDataService
  ) {
    super(dialog, snackBar, sharedService, formBuilder, fittingSizeDataService);
  }
  setDisabledColumns() {
    if (this.getSharedService().getSelectedFitting().unitID === 1 && this.getSharedService().getActionPage() === 'Update') {
      this.disabledColumns = [
        'BDID',
        'NominalSize',
        'DecDepth1',
        'DecDepth2',
        'DecDepth3',
        'DecDepth4',
        'DecDepth5',
        'DecDepth6',
        'DecWidth1',
        'DecWidth2',
        'DecWidth3',
        'DecWidth4',
        'DecWidth5',
        'DecWidth6',
        'WeightMetric'
      ];
    } else if (this.getSharedService().getSelectedFitting().unitID === 1) {
      this.disabledColumns = [
        'BDID',
        'DecDepth1',
        'DecDepth2',
        'DecDepth3',
        'DecDepth4',
        'DecDepth5',
        'DecDepth6',
        'DecWidth1',
        'DecWidth2',
        'DecWidth3',
        'DecWidth4',
        'DecWidth5',
        'DecWidth6',
        'WeightMetric'
      ];
    } else {
      this.disabledColumns = [
        'BDID',
        'DecDepth1',
        'DecDepth2',
        'DecDepth3',
        'DecDepth4',
        'DecDepth5',
        'DecDepth6',
        'DecWidth1',
        'DecWidth2',
        'DecWidth3',
        'DecWidth4',
        'DecWidth5',
        'DecWidth6',
        'WeightImperial'
      ];
    }
  }
}
